import { Action, AppState } from "./AppProvider";
import { Conversation, ConversationFolder, ScenarioFolder, Scenario } from "../api";

const deleteFolder = (state: any, id: string, folders: Map<string, any>, stateName: string): any => {
    const existingFolder = folders.get(id);
    if (existingFolder) {
        const updatedFolders = new Map<string, any>(folders);
        updatedFolders.delete(id);
        return { ...state, [stateName]: updatedFolders };
    }
    return state;
};

const addFolder = (state: any, folder: any, folders: Map<string, any>, stateName: string): any => {
    const updatedFolders = new Map([[folder.id, folder], ...folders.entries()]);
    return { ...state, [stateName]: updatedFolders };
};
const updateFolder = (state: any, folder: any, folders: Map<string, any>, stateName: string): any => {
    if (folders.has(folder.id)) {
        const updatedFolders = new Map<string, any>(folders);
        updatedFolders.set(folder.id, folder);
        return { ...state, [stateName]: updatedFolders };
    }
    return state;
};

export const appStateReducer = (state: AppState, action: Action): AppState => {
    switch (action.type) {
        case "TOGGLE_LEFT_SIDE":
            return { ...state, isLeftSideOpen: !state.isLeftSideOpen };
        case "UPDATE_CURRENT_CHAT":
            return { ...state, currentChat: action.payload };
        case "UPDATE_CHAT_HISTORY_LOADING_STATE":
            return { ...state, chatHistoryLoadingState: action.payload };
        case "UPDATE_SCENARIO_LOADING_STATE":
            return { ...state, scenarioLoadingState: action.payload };
        case "UPDATE_CHAT_HISTORY":
            const folderToLookupUpdateHistory = action.payload.folder_id || "-100";
            const folderToUpdateHistory = state.conversationFolders.get(folderToLookupUpdateHistory);
            if (folderToUpdateHistory) {
                const conversations = folderToUpdateHistory.conversations || new Array<Conversation>();
                const conversationIndex = conversations.findIndex(
                    (conversation) => conversation.id === action.payload.id,
                );
                if (conversationIndex !== -1) {
                    conversations[conversationIndex] = action.payload;
                    const updatedFolders = new Map<string, ConversationFolder>(state.conversationFolders);
                    folderToUpdateHistory.conversations = conversations;
                    updatedFolders.set(folderToLookupUpdateHistory, folderToUpdateHistory);
                    return { ...state, conversationFolders: updatedFolders };
                } else {
                    const updatedFolders = new Map<string, ConversationFolder>(state.conversationFolders);
                    const updatedConversations = [...(folderToUpdateHistory.conversations || []), action.payload];
                    folderToUpdateHistory.conversations = updatedConversations;
                    updatedFolders.set(folderToLookupUpdateHistory, folderToUpdateHistory);
                    return { ...state, conversationFolders: updatedFolders };
                }
            }
            return state;
        case "UPDATE_CHAT_TITLE":
            const folderToLookupUpdate = action.payload.folder_id || "-100";
            const folderToUpdate = state.conversationFolders.get(folderToLookupUpdate);
            if (folderToUpdate) {
                const conversations = folderToUpdate.conversations || new Array<Conversation>();
                const conversationIndex = conversations.findIndex(
                    (conversation) => conversation.id === action.payload.id,
                );
                if (conversationIndex !== -1) {
                    conversations[conversationIndex] = {
                        ...conversations[conversationIndex],
                        title: action.payload.title,
                    };
                    const updatedFolders = new Map<string, ConversationFolder>(state.conversationFolders);
                    folderToUpdate.conversations = conversations;
                    updatedFolders.set(folderToLookupUpdate, folderToUpdate);
                    return { ...state, conversationFolders: updatedFolders };
                }
            }
            return state;
        case "DELETE_CHAT_ENTRY":
            const folderToLookupDelete = action.payload.folder_id || "-100";
            const folderToDelete = state.conversationFolders.get(folderToLookupDelete);
            if (folderToDelete) {
                const conversations = folderToDelete.conversations || new Array<Conversation>();
                const conversationIndex = conversations.findIndex(
                    (conversation) => conversation.id === action.payload.id,
                );
                if (conversationIndex !== -1) {
                    const updatedConversations = conversations.filter(
                        (conversation) => conversation.id !== action.payload.id,
                    );
                    const updatedFolders = new Map<string, ConversationFolder>(state.conversationFolders);
                    folderToDelete.conversations = updatedConversations;
                    updatedFolders.set(folderToLookupDelete, folderToDelete);
                    return {
                        ...state,
                        conversationFolders: updatedFolders,
                        chatHistoryVersion: state.chatHistoryVersion + 1,
                    };
                }
            }
            return { ...state, chatHistoryVersion: state.chatHistoryVersion + 1 };
        case "DELETE_CURRENT_CHAT_MESSAGES":
            //TODO: make api call to delete current conversation messages from DB
            if (!state.currentChat || !state.chatHistory) {
                return state;
            }
            const updatedCurrentChat = {
                ...state.currentChat,
                messages: [],
            };
            return {
                ...state,
                currentChat: updatedCurrentChat,
            };
        case "FETCH_CHAT_HISTORY_NO_FOLDER":
            if (state.conversationFolders.has("-100")) {
                const updatedConversationFolders = new Map<string, ConversationFolder>(state.conversationFolders);
                const existingFolder = updatedConversationFolders.get("-100");
                if (existingFolder) {
                    updatedConversationFolders.set("-100", {
                        ...existingFolder,
                        conversations: action.payload,
                    });
                }
                return { ...state, conversationFolders: updatedConversationFolders };
            } else {
                const noneFolder = {
                    id: "-100",
                    name: "none",
                    conversations: action.payload,
                };
                const updatedConversationFolders = new Map<string, ConversationFolder>(state.conversationFolders);
                updatedConversationFolders.set("-100", noneFolder);
                return { ...state, conversationFolders: updatedConversationFolders };
            }
        case "ADD_LOADED_MESSAGES":
            const existingFolder = state.conversationFolders.get(action.payload.id);
            if (existingFolder) {
                const existingConversations = existingFolder.conversations || new Array<Conversation>();
                const existingConversationIndex = existingConversations.findIndex(
                    (conversation) => conversation.id === action.payload.id,
                );
                if (existingConversationIndex !== -1) {
                    const updatedConversationFolders = new Map<string, ConversationFolder>(state.conversationFolders);
                    const updatedConversations = existingConversations.slice();
                    updatedConversations[existingConversationIndex] = {
                        ...updatedConversations[existingConversationIndex],
                        messages: action.payload.messages,
                    };
                    existingFolder.conversations = updatedConversations;
                    updatedConversationFolders.set(action.payload.id, existingFolder);
                    return { ...state, conversationFolders: updatedConversationFolders };
                }
            }
            return state;

        case "SET_COSMOSDB_STATUS":
            return { ...state, isCosmosDBAvailable: action.payload };
        case "UPDATE_GPT_MODEL_NAME":
            return {
                ...state,
                gptModelSettings: {
                    ...state.gptModelSettings,
                    name: action.payload,
                },
            };
        case "UPDATE_GPT_MODEL_SETTINGS":
            return {
                ...state,
                gptModelSettings: {
                    ...state.gptModelSettings,
                    settings: action.payload,
                },
            };
        case "UPDATE_GLOBAL_SETTINGS":
            if (action.payload === null) {
                return state;
            } else {
                return {
                    ...state,
                    globalSettings: action.payload,
                };
            }
        case "UPDATE_SELECTED_SCENARIO":
            return {
                ...state,
                selectedScenario: action.payload,
            };
        case "FETCH_CONVERSATION_FOLDERS":
            const conversationFoldersMap = new Map<string, ConversationFolder>();
            action.payload.forEach((folder) => {
                conversationFoldersMap.set(folder.id, folder);
            });
            return { ...state, conversationFolders: conversationFoldersMap };
        case "ADD_CONVERSATION_FOLDER":
            return addFolder(state, action.payload, state.conversationFolders, "conversationFolders");
        case "DELETE_CONVERSATION_FOLDER":
            return deleteFolder(state, action.payload.id, state.conversationFolders, "conversationFolders");
        case "UPDATE_CONVERSATION_FOLDER":
            return updateFolder(state, action.payload, state.conversationFolders, "conversationFolders");
        case "MOVE_CONVERSATION":
            const { conversationId, oldFolderId, newFolderId } = action.payload;
            const oldFolder = state.conversationFolders.get(oldFolderId);
            const newFolder = state.conversationFolders.get(newFolderId);

            if (oldFolderId === newFolderId) {
                return state;
            }

            if (oldFolder && newFolder) {
                const conversationIndex =
                    oldFolder.conversations?.findIndex((conversation) => conversation.id === conversationId) ?? -1;

                if (conversationIndex !== -1) {
                    if (!oldFolder.conversations) {
                        return state;
                    }

                    const conversationToMove: Conversation = oldFolder.conversations[conversationIndex];
                    if (!conversationToMove) {
                        return state;
                    }
                    conversationToMove.folder_id = newFolderId;

                    // Remove conversation from old folder
                    const updatedOldFolder = {
                        ...oldFolder,
                        conversations:
                            oldFolder.conversations?.filter((conversation) => conversation.id !== conversationId) ?? [],
                    };
                    // Add conversation to new folder
                    const updatedNewFolder = {
                        ...newFolder,
                        conversations: [conversationToMove].concat(newFolder.conversations ?? []) as Conversation[],
                    };

                    const updatedConversationFolders = new Map<string, ConversationFolder>(state.conversationFolders);
                    updatedConversationFolders.set(oldFolderId, updatedOldFolder);
                    updatedConversationFolders.set(newFolderId, updatedNewFolder);

                    return {
                        ...state,
                        conversationFolders: updatedConversationFolders,
                    };
                }
            }
            return state;
        case "FETCH_SCENARIO_FOLDERS":
            const foldersMap = new Map<string, ScenarioFolder>();
            action.payload.forEach((folder) => {
                foldersMap.set(folder.id, folder);
            });
            return { ...state, scenarioFolders: foldersMap };
        case "ADD_SCENARIO_FOLDER":
            return addFolder(state, action.payload, state.scenarioFolders, "scenarioFolders");
        case "DELETE_SCENARIO_FOLDER":
            return deleteFolder(state, action.payload.id, state.scenarioFolders, "scenarioFolders");
        case "UPDATE_SCENARIO_FOLDER":
            return updateFolder(state, action.payload, state.scenarioFolders, "scenarioFolders");
        case "MOVE_SCENARIO":
            const { scenarioId, oldFolderScenarioId, newFolderScenarioId } = action.payload;
            const oldFolderScenario = state.scenarioFolders.get(oldFolderScenarioId);
            const newFolderScenario = state.scenarioFolders.get(newFolderScenarioId);

            if (oldFolderScenarioId === newFolderScenarioId) {
                return state;
            }

            if (oldFolderScenario && newFolderScenario) {
                const scenarioIndex =
                    oldFolderScenario.scenarios?.findIndex((scenario) => scenario.scenario_id === scenarioId) ?? -1;

                if (scenarioIndex !== -1) {
                    if (!oldFolderScenario.scenarios) {
                        return state;
                    }

                    const scenarioToMove: Scenario = oldFolderScenario.scenarios?.[scenarioIndex];
                    if (!scenarioToMove) {
                        return state;
                    }
                    scenarioToMove.folder_id = newFolderScenarioId;

                    const updatedOldFolderScenarios = {
                        ...oldFolderScenario,
                        scenarios:
                            oldFolderScenario.scenarios?.filter((scenario) => scenario.scenario_id !== scenarioId) ??
                            [],
                    };
                    const updatedNewFolderScenarios = {
                        ...newFolderScenario,
                        scenarios: [scenarioToMove].concat(newFolderScenario.scenarios ?? []) as Scenario[],
                    };

                    const updatedScenarioFolders = new Map<string, ScenarioFolder>(state.scenarioFolders);
                    updatedScenarioFolders.set(oldFolderScenarioId, updatedOldFolderScenarios);
                    updatedScenarioFolders.set(newFolderScenarioId, updatedNewFolderScenarios);

                    return { ...state, scenarioFolders: updatedScenarioFolders };
                }
            }
            return state;
        case "DELETE_SCENARIO":
            const scenarioFolderToLookupDelete = action.payload.folder_id || "-100";
            const scenarioToDelete = state.scenarioFolders.get(scenarioFolderToLookupDelete);
            if (scenarioToDelete) {
                const scenarios = scenarioToDelete.scenarios || new Array<Scenario>();
                const scenarioIndex = scenarios.findIndex(
                    (scenario) => scenario.scenario_id === action.payload.scenario_id,
                );
                if (scenarioIndex !== -1) {
                    const updatedScenarios = scenarios.filter(
                        (scenario) => scenario.scenario_id !== action.payload.scenario_id,
                    );
                    const updatedFolder = { ...scenarioToDelete, scenarios: updatedScenarios }; // Create a new ScenarioFolder object
                    const updatedFolders = new Map<string, ScenarioFolder>(state.scenarioFolders.entries());
                    updatedFolders.set(scenarioFolderToLookupDelete, updatedFolder); // Use the new ScenarioFolder object
                    return { ...state, scenarioFolders: updatedFolders };
                }
            }
            return state;
        case "UPDATE_SCENARIO":
            const scenarioFolderToLookup = action.payload.folder_id || "-100";
            const scenarioFolderToUpdate = state.scenarioFolders.get(scenarioFolderToLookup);
            if (scenarioFolderToUpdate) {
                const scenarios = scenarioFolderToUpdate.scenarios || new Array<Scenario>();
                const scenarioIndex = scenarios.findIndex(
                    (scenario) => scenario.scenario_id === action.payload.scenario_id,
                );
                if (scenarioIndex !== -1) {
                    const updatedScenarios = scenarios.map((scenario) => {
                        if (scenario.scenario_id === action.payload.scenario_id) {
                            return action.payload;
                        }
                        return scenario;
                    });
                    const updatedFolder = { ...scenarioFolderToUpdate, scenarios: updatedScenarios }; // Create a new ScenarioFolder object
                    const updatedFolders = new Map<string, ScenarioFolder>(state.scenarioFolders.entries());
                    updatedFolders.set(scenarioFolderToLookup, updatedFolder); // Use the new ScenarioFolder object
                    return { ...state, scenarioFolders: updatedFolders };
                }
            }
            return state;

        case "ADD_SCENARIO":
            const scenarioAddFolderToLookup = action.payload.folder_id || "-100";
            const scenarioAddFolderToUpdate = state.scenarioFolders.get(scenarioAddFolderToLookup);
            if (scenarioAddFolderToUpdate) {
                const scenarios = scenarioAddFolderToUpdate.scenarios || new Array<Scenario>();
                if (!scenarios.some((scenario) => scenario.scenario_id === action.payload.scenario_id)) {
                    const updatedScenarios = [action.payload, ...scenarios];
                    const updatedFolder = { ...scenarioAddFolderToUpdate, scenarios: updatedScenarios }; // Create a new ScenarioFolder object
                    const updatedFolders = new Map<string, ScenarioFolder>(state.scenarioFolders.entries());
                    updatedFolders.set(scenarioAddFolderToLookup, updatedFolder); // Use the new ScenarioFolder object
                    return { ...state, scenarioFolders: updatedFolders };
                }
            }
            return state;
        case "UPDATE_NUM_HISTORIC_MESSAGES":
            return { ...state, numHistoricMessages: action.payload };
        case "UPDATE_ACCEPTED_TERMS_OF_USE":
            return { ...state, acceptedTermsOfUse: action.payload };
        case "SET_ERROR":
            return { ...state, errorMessage: action.payload };
        case "UPLOADED_FILE":
            return { ...state, uploadedFile: action.payload };
        default:
            return state;
    }
};
